export default (function (x, y) {
  return "translate(".concat(x, ", ").concat(y, ")");
});